module.exports = __webpack_public_path__ + "static/media/terms-conditions.44f31650.png";